import React from 'react';

const NotificationDropdown: React.FC = () => null;

export default NotificationDropdown;
